import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DPAccount } from './dp-account';
import { DPAccountService } from './dp-accounts.service';
import { DPCustomer } from './dp-customer';
import { DPSubscriptionService } from './dp-subscriptions.service';
import { DPMarket } from './model/dp-market';
import { Router } from '@angular/router';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';



@Component({
    templateUrl: 'dp-account-create.component.html'
})
export class DPAccountCreateComponent implements OnInit {
    @Input() account: DPAccount;
    @Output() close = new EventEmitter();
    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    storedStatus: number;
    isFirst: any;
    customer: DPCustomer;
    marketLists: DPMarket[];
    marketFilteredList: DPMarket[];
    query: string;
    selectedMarket: DPMarket;
    marketName: any;
    requstedCustomerId: number;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    marketSearchSelected = false;
    marketSearchBoxSelected = false;
    firstFilter = true;
    submitting = false;
    selectedAccountType = 'internal';
    accesstypes = ['internal', 'subscription', 'earlyaccess', 'churned', 'oneoff'];

    constructor(
        private toasterService: ToasterService,
        private router: Router,
        private accountService: DPAccountService,
        private subscriptionService: DPSubscriptionService,
        private route: ActivatedRoute) {
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }


    getMarkets() {
        return this.subscriptionService
            .getMarkets()
            .then(res => {
                this.marketLists = res.subscriptions.markets;
            })
            .catch(error => this.errorHandler(error));

    }
    filterMarket(term: string) {
        this.selectedMarket = undefined;
        if (term !== '') {
            this.query = term;
            this.marketFilteredList = this.marketLists.filter(u => u.displayName.toLowerCase().includes(term.toLowerCase()));
        } else {
            this.marketFilteredList = this.marketLists;
        }

    }
    ngOnInit() {

        this.customer = new DPCustomer;
        this.getMarkets();
        this.route.params.forEach((params: Params) => {
            const customer_id = params['customerId'];
            this.requstedCustomerId = customer_id;
            this.navigated = true;
            this.customer.customer_id = customer_id;
        });



        this.account = new DPAccount();
        this.storedStatus = 1;
        this.isFirst = true;

    }
    save1(account: DPAccount, isValid: boolean) {
        if (isValid == true) {
            this.submitting = true;
            const searchIndex = this.marketLists.findIndex(x => x.displayName.toLowerCase() == this.query.toLowerCase());

            if (searchIndex > -1) {
                account.home_market = this.marketLists[searchIndex].id;
                account.customer = this.customer;
                account.status = this.storedStatus;
                account.account_type = this.selectedAccountType;
                this.save(account);

            }

            else {
                this.submitting = false;
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                this.notificationContent = this.query + ' is not valid market';
                this.createNotification();
            }

        }
    }

    checkStatus() {
        if (this.storedStatus == 0) {
            this.storedStatus = 1;
        }
        else {
            this.storedStatus = 0;
        }
    }


    save(account: DPAccount) {
        this.account = account;
        this.accountService
            .createAccount(this.account)
            .then(account => {
                this.account = account;
                this.goBack(); // saved hero, w/ id if new
            })
            .catch(error => this.errorHandler(error));

    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account', this.requstedCustomerId]);
        }
    }


    public activeStatus = [
        { value: 0, display: 'Inactive' },
        { value: 1, display: 'Active' },
    ];

    selectMarket(market: DPMarket) {
        this.marketSearchSelected = true;
        this.query = market.displayName;
        this.marketFilteredList = [];
        this.selectedMarket = market;
    }
    onFocus() {
        if (this.marketSearchBoxSelected == false) {
            this.marketSearchBoxSelected = true;
            this.marketFilteredList = this.marketLists;
        }

    }
    handleBlur() {
        setTimeout(() => {
            this.marketFilteredList = [];
        }, 200);
    }


    checkExistingAccess(access: string) {
        if (access == this.selectedAccountType) {
            return true;
        }
        return false;
    }

    checkAccess(access: string) {
        this.selectedAccountType = access;
    }

}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-account-create.component.ts